module.exports = __webpack_public_path__ + "img/yt.242e9c1b.png";